<template>
  <div>
    <div v-if="loading">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </div>
    <div v-else>
      <app-form v-bind:parentObject="{
        data: this.formData,
        pageTitle: this.pageTitle,
        pageTitleValue: this.pageTitleValue,
        errMsg: this.errMsg,
        isEdit: this.isEdit,
        isAdvanceEdit: this.isAdvanceEdit,
        pmAssessmentRecordDetailList: this.pmAssessmentRecordDetailList,
      }"/>

      <div v-if="isErr">
        <app-error v-bind:parentError="{
          data: this.errMsg,
          isErr: this.isErr,
        }"/>
      </div>
    </div>
  </div>
</template>

<script>
import PMAssessmentRecordDetailForm from "../../../components/performance/assessmentrecord/FormDetail";
import moment from 'moment';
import ErrorDialog from '../../../components/common/ErrorDialog';

export default {
  components: {
    "app-form": PMAssessmentRecordDetailForm,
    'app-error': ErrorDialog
  },

  data() {
    return {
      pageTitle: this.$t('pmassementrecord.assementresultfor'),
      pageTitleValue: '',
      id: this.$route.params.id,

      formData: {
        id: this.$route.params.id,
        pmassessmentrecordcode:null,
        pmassessmentrecorddesc: null,
        startdate: null,
        enddate: null,
        // cutoffdate: null,
        // statusid: null,
        // ratingtype: null,
        ratingid:null,
        ratingcode: null,
        // ramark:null,
        // calmethod: null,
        // stamp: null,
        userid: this.$store.getters.userId,
        statusdesc:null,
        ratingtypename:null,
        calculationmethodname : null
      },
      errMsg: "",
      isErr: false,
      loading: true,
      isEdit: true,
      isAdvanceEdit:true,
      pmAssessmentRecordDetailList: [],
    };
  },

  methods: {
    async loadPerformanceAssessmentRecordHandler() {
      this.isErr = false;
      this.errMsg = "";

      try {
        const res = await this.$store.dispatch('get', { url: `/performanceassessmentrecord/${this.id}` });
        if (res.status === 200 && res.data.rec) {
            this.formData = { ...res.data.rec };
            if (this.formData.startdate) {
                this.formData.startdate = moment(this.formData.startdate).format('YYYY-MM-DD');
            }
            if (this.formData.enddate) {
                this.formData.enddate = moment(this.formData.enddate).format('YYYY-MM-DD');
            }
            if (this.formData.cutoffdate) {
              this.formData.cutoffdate = moment(this.formData.cutoffdate).format('YYYY-MM-DD');
            }
            this.formData.userid = this.$store.getters.userId;
            this.pageTitleValue = this.formData.pmassessmentrecordcode || "Untitled Record"; 
        } else {
            this.isErr = true;
            console.error("data not found");
            this.errMsg = "Record not found.";
        }
      } catch (err) {
          console.error("Error loading record:", err);
          this.isErr = true;
          this.errMsg = err.message || "Network Error";
      }
    },

    async loadPMAssessmentRecordDetailHandler() {
      try {
        const res = await this.$store.dispatch('get', { url: "/performanceassessmentrecorddetaillist/" + this.id });
        this.pmAssessmentRecordDetailList = res.data.rec;
      } catch (err) {
          this.isErr = true;
          this.errMsg = err;
      }
    },
    
  },

  async mounted() {
    try {
      await this.loadPerformanceAssessmentRecordHandler();
      await this.loadPMAssessmentRecordDetailHandler();
      this.loading = false; // Set loading to false after all data is loaded
    } catch (error) {
      console.error("Something went wrong during mounted:", error);
      this.isErr = true;
      this.errMsg = error;
    }
  }

};
</script>